// Build information, automatically generated by `ng-info`
const build = {
    version: "25.2.0",
    timestamp: "Thu Nov 05 2026 11:54:17 GMT+0100 (Central European Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "HEAD",
        hash: "5ff8ef",
        fullHash: "5ff8efa7269fd0e7401e1b4d6b03544b029da891"
    }
};

export default build;